import { useState } from 'react';

/** hierarchy : vue du prototype Figma (niveaux en escalier) ; tree : organigramme classique, de haut en bas */
export type OrgChartView = 'hierarchy' | 'tree';

/**
 * Vue de l'organigramme : arbre à chaque arrivée, sur mobile comme en desktop (lisible partout, la hiérarchie déborde
 * sur mobile), non mémorisée (la mémorisation des choix d'affichage est à
 * rediscuter en fin de projet, chef de projet 2026-10-29)
 */
export function useOrgChartView(): [OrgChartView, (view: OrgChartView) => void] {
  return useState<OrgChartView>('tree');
}
